<template>
    <v-container>
        <v-combobox 
            :items="items" 
            v-model="model.selectedValue" 
            @change="onChange"
            label="Test Drop Input"
            return-object
            dense solo ></v-combobox>

            <v-dialog v-model="dialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="text-h5">
                        Add new Building
                    </v-card-title>
                    <v-card-text>
                        Do you want to add a new Building to the list?
                    </v-card-text>
                    <v-card-text>
                        <v-form ref="formNewBuilding" v-model="valid" lazy-validation>
                            <v-text-field dense label="Code" v-model="newBuilding.code" prepend-icon="edit" :rules="[v=>!!v || 'Buiding Code is required']" required></v-text-field>
                            <v-text-field dense label="Description" v-model="newBuilding.description" prepend-icon="edit" :rules="[v=>!!v || 'Buiding Description is required']" required></v-text-field>
                        
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text @click="dialog=false">Cancel</v-btn>
                                <v-btn color="green darken-1" text @click="onSaveNewBuilding">Agree</v-btn>
                            </v-card-actions>
                    </v-form>
                    </v-card-text>
                    
                    
                </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-btn @click="testEmailAPI">Test email api</v-btn>
    </v-container>

    
</template>
<script>



class DropBoxAdapaterValueandText{
    constructor(initializer){
        this.text=initializer.value +' - '+initializer.text;
        this.value=initializer.value;
        this.disabled=false;
        this.divider=false;
    }
}

import userAPI from '@/services/userservice';

export default{
name:'TestDropBoxInput',
data:function(){
     return {
         model:{
              selectedValue:null
          },
         itemsData:[
             { value:'1', text : 'One'},
             {value: '2', text: 'two'},
             {value: '3' , text :'three'}
            ],
         items:[],
         dialog:false,
         newBuilding:{
             code:'',
             description:''
         },
         valid:false
     }
    },
    methods:{
        addNewItem: async function(entry)
        {
            const newItem={value:entry.code, text:entry.description}
            this.itemsData.push(newItem);
            console.log(newItem);
            return newItem;
        },
        loadItems: async function(){
            this.items=this.itemsData.map(item=>new DropBoxAdapaterValueandText(item));
            
        },
        async onChange(entry) {
            console.log('Type',typeof(entry));
            if(typeof(entry)==='string' && entry.trim()){
                var splited=[];
                var value='';
                
                if(entry.includes('-'))
                {
                    splited=entry.split('-');
                    value=splited[0].trim();
                }
                else{
                    value=entry;
                }
                const item=this.items.find(item=>item.value===value);
                console.log('item finded', item);
                if(item){
                    this.model.selectedValue={value:item.value, text: item.value+' - '+ item.text };
                } else{
                    // Validar - para guardar en el catalogo
                        const splited=entry.split('-');
                        this.newBuilding={ code:splited[0].trim(), description:splited[1].trim()}
                        this.dialog=true;   
                }
            }
        },
        async onSaveNewBuilding(){
            
            if(this.$refs.formNewBuilding.validate())
            {
                
                const selected= await this.addNewItem(this.newBuilding);
                console.log(selected.value, selected.text);
                await this.loadItems();
                this.model.selectedValue={value: selected.value, text: selected.value+' - '+ selected.text };
                console.log("Saving new building");
                this.dialog=false;
            }
            else{
                console.log("Validation error");
            }
        },
        async testEmailAPI(){
            const email={
                subject:'Test from Radiation Application', 
                content:'This email is sending as part of the testing for notification service from Radiation System', 
                htmlContent:false,
                to: ['juan.bermudezcamacho@eastman.com', 'jspence@eastman.com'], 
                cc:[],
                bcc:[]
             };
            await userAPI.testEmailSendFrom(email);
        }
    },
    mounted:async function(){
        await this.loadItems();
    }
}
</script>
